export const CONFIG = {
  LATEST_VERSION: 'v1.36.3'
}